import React from 'react'
import UserEventsForm from '../components/userEvents/UserEventsForm'
import { Redirect } from 'react-router-dom'

import useUserEventsApi from '../hooks/userEvents/useUserEventsApi'
import { useParams } from 'react-router-dom'
import UserInvitationSuccessPage from './UserInvitationPageSuccess'

export default function UserInvitationsPage() {
  const [{ eventsState }, { getUserEvent, addInvitation }] = useUserEventsApi()
  let { id } = useParams()
  const [formSubmitted, setFormSubmitted] = React.useState(false)
  React.useEffect(() => {
    getUserEvent(id)
  }, [])

  if (
    !eventsState.error &&
    !eventsState.isLoading &&
    formSubmitted &&
    eventsState?.getResponse
  ) {
    return (
      <UserInvitationSuccessPage
        code={eventsState?.getResponse?.code}
      ></UserInvitationSuccessPage>
    )
    // return <Redirect to="/userInvitationsSuccess" />
  }

  return (
    <UserEventsForm
      onSubmit={(data) => {
        addInvitation(id, data)
        setFormSubmitted(true)
      }}
      responseError={eventsState.error}
      userEvent={eventsState?.getResponse}
      loading={eventsState.isLoading}
    />
  )
}
